import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { AuthService } from '@spartacus/core';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { KbNotificationsService } from 'src/app/services/feature/Notifications/kb-notifications.service';

@Component({
  selector: 'app-kb-notifications',
  templateUrl: './kb-notifications.component.html',
  styleUrl: './kb-notifications.component.scss',
  standalone: false
})
export class KbNotificationsComponent {
  showNotification: boolean = false;
  isLoggedIn: boolean;

  notificationsData: any;
  notificationCount: any;
  subscription = new Subscription();
  constructor(
    private authService: AuthService,
    private notificationService: KbNotificationsService,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2, private el: ElementRef
  ) { }

  ngOnInit() {
    this.getNotificationCount();
    this.subscription.add(this.authService
      .isUserLoggedIn()
      .pipe(distinctUntilChanged())
      .subscribe((data: boolean) => {
        this.isLoggedIn = data;
        if (!this.isLoggedIn) {
          this.showNotification = false;
        }
      }));

  }

  getNotificationCount() {
    this.subscription.add(this.notificationService.getNotificationCount().subscribe((x) => {
      this.notificationCount = x?.['count'];
      this.cdr.detectChanges();
    }));
  }
  getNotification() {
    this.showNotification = !this.showNotification;
    if (this.showNotification) {
      this.subscription.add(this.notificationService.getNotifications().subscribe((notification) => {
        this.notificationCount = notification?.['count'];
        this.notificationsData = notification;
        this.cdr.detectChanges();
      }));
    }
  }

  deleteNotification(code) {
    this.subscription.add(this.notificationService.deleteNotification(code).subscribe((notification) => {
      this.notificationCount = notification?.['count'];
      this.notificationsData = notification;
      if (!this.notificationCount) {
        this.showNotification = !this.showNotification;
      }
      this.cdr.detectChanges();
    }));
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }


}
